import { ResponseType } from 'axios'
import { authorizedEdgeFetch } from 'app/axios/edge'

interface fetchTemplateFileProps {
  url: string
  responseType: ResponseType
  contentType: string
}

export const fetchTemplateFile = ({
  url,
  responseType,
  contentType,
}: fetchTemplateFileProps) =>
  authorizedEdgeFetch.get(url, {
    responseType,
    headers: { Accept: contentType },
  })

export const deleteTemplate = (configId: string) =>
  authorizedEdgeFetch.delete(`/config/delete/${configId}`)
